import React from 'react';
import Notification from '../messagerie_user/notification';
import InvitationJoueur from './invitationJoueur';
import CotisationCoach from './cotisationCoach';
import CardAccueil from './cardAccueil';
import NavCoach from '../navigation/navCoach';

function ProfilCoach(props) {


  return (
    <>
      <NavCoach userData={props.userData} nom='Accueil'/>
      <div className="main profil_">
      <Notification userData = {props.userData}/>
      <CardAccueil nom={props.userData.user.donnée.results[0].nom_coach} prenom={props.userData.user.donnée.results[0].prenom}/>
      <br/>
        <div className="card">
        <h2 >Identité</h2>
          <div className="card-body">
            <table>
              <tbody>
                <tr>
                  <td>Nom</td>
                  <td>:</td>
                  <td> {props.userData.user.donnée.results[0].nom_coach}</td>
                </tr>
                <tr>
                  <td>Prénom</td>
                  <td>:</td>
                  <td> {props.userData.user.donnée.results[0].prenom}</td>
                </tr>
                <tr>
                  <td>Email</td>
                  <td>:</td>
                  <td> {props.userData.user.donnée.results[0].email}</td>
                </tr>
                <tr>
                  <td>Numéro de téléphone</td>
                  <td>:</td>
                  <td> {props.userData.user.donnée.results[0].contact}</td>
                </tr>
                <tr>
                  <td>Club</td>
                  <td>:</td>
                  <td>{props.userData.user.donnée.results[0].nom_equipe}</td>
                </tr>
                <tr>
                  <td>Adresse du club</td>
                  <td>:</td>
                  <td>{props.userData.user.donnée.results[0].adresse}</td>
                </tr>
                <tr>
                  <td>Catégorie</td>
                  <td>:</td>
                  <td>{props.userData.user.donnée.results[0].categorie}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <br/>
          <hr></hr>
          <br/>
          <InvitationJoueur userData={props.userData}/>
          <br/>
          <hr></hr>
          <br/>
          <CotisationCoach userData={props.userData}/>
        </div>
      </div>
      
    </>
    
  );
}

export default ProfilCoach;
